"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const ModalDefault_1 = require("./ModalDefault");

const styles_1 = require("../styles");

const Icons_1 = require("../../Icons");

const styles_2 = require("./styles");

const Modal = props => {
  const {
    children,
    onClose,
    title
  } = props;
  return (0, jsx_runtime_1.jsx)(ModalDefault_1.ModalDefault, Object.assign({}, props, {
    children: (0, jsx_runtime_1.jsxs)(styles_1.StyledModal, {
      children: [(0, jsx_runtime_1.jsx)(styles_2.StyledTitle, {
        children: title
      }, void 0), (0, jsx_runtime_1.jsx)(styles_1.StyledButtonClose, Object.assign({
        onClick: onClose
      }, {
        children: (0, jsx_runtime_1.jsx)(Icons_1.CloseCircled, {}, void 0)
      }), void 0), children]
    }, void 0)
  }), void 0);
};

exports.default = Modal;